import { render, staticRenderFns } from "./extraTable.vue?vue&type=template&id=ca9f500a&"
import script from "./extraTable.vue?vue&type=script&lang=js&"
export * from "./extraTable.vue?vue&type=script&lang=js&"
import style0 from "./extraTable.vue?vue&type=style&index=0&id=ca9f500a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports